const LogoutIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="size-6 shrink-0">
    <path
      d="M6.99758 15.0012L3.99633 11.9999L6.99758 8.99866"
      stroke="#898994"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16.0015 12H3.99648" stroke="#898994" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M10.0002 21H17.7014C18.971 21 20.0002 19.9756 20.0002 18.7119V5.28814C20.0002 4.02444 18.971 3 17.7014 3H10.0002"
      stroke="#898994"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Logout = ({ formOnly = false }: { formOnly?: boolean }) => {
  return (
    <form
      id="logoutForm"
      action="/umbraco/surface/LoginSurface/Logout"
      encType="multipart/form-data"
      method="post"
      className={formOnly ? "flex gap-2" : "w-full"}>
      {!formOnly && (
        <button
          type="submit"
          className="flex items-center w-full h-14 px-4 gap-4 bg-white rounded-lg cursor-pointer text-left">
          <LogoutIcon />
          <span className="flex-1 min-w-0 text-base font-roboto font-normal leading-5.5 text-secondary break-words">
            Log out
          </span>
        </button>
      )}
    </form>
  );
};

export default Logout;
